module.exports = __webpack_public_path__ + "static/media/ck.d66de29c.svg";